import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GlobalContextProvider } from './contexts/GlobelContext';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <GlobalContextProvider>
      <App />
    </GlobalContextProvider>
  </React.StrictMode>
);
